<template>
  <footer class="footer px-4">
    <b-row align-v="center" class="justify-content-lg-between">
      <b-col lg="6">
        <div class="copyright text-center text-lg-left text-muted">
          <img src="@/assets/logo-pam.png" class="logo-rodape" />
        </div>
      </b-col>

      <b-col lg="6" class="text-right">
        <img src="@/assets/desenvolve-logo.png" class="logo-rodape" />
      </b-col>
    </b-row>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
